import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template180: Seguridad SF - bloques desde page (header, intro, sections: title + body, logo)
const Template180 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const isSmallScreen = useWindowSize().width <= 600;
	const contentColor = textColor || "#444";

	const headerText =
		page.texts?.[0]?.content ?? "Seguridad: zonas menos recomendables";
	const introText = page.texts?.[1]?.content ?? "";
	const getCanvasImageUrl = (id) =>
		page.canvasImages?.find((img) => img.id === id)?.imageUrl ?? "";
	const logoImage = getCanvasImageUrl("logo");
	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];

	const box = {
		backgroundColor: "#fbf0cf",
		border: "2px solid #F2B705",
		borderRadius: "16px",
		padding: "16px",
	};
	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 1,
		marginTop: 0,
		color: "#ca9904",
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100vh",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: headerBackgroundColor || "#F2B705",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* ——— Intro ——— */}
			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{/* ——— Zonas ——— */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{sections.map((sec, i) => (
					<Box key={i} data-block-id={`text-${i + 3}`} sx={box}>
						{sec.title && (
							<Box component="h3" sx={h3}>
								{sec.title}
							</Box>
						)}
						{sec.body && (
							<Box
								component="p"
								sx={p}
								dangerouslySetInnerHTML={{ __html: sec.body }}
							/>
						)}
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template180.thumbnail = "/images/template-1.png";
export default Template180;
